/**
 * More
 */

import Config from '../Config';
import Util from '../Util';
import Template from './Template';
import Loading from '../Loading';
import ParamInfo from './ParamInfo';
import GoToTop from '../GoToTop';

const NEW_ICON = ` <i class="ic-new">new</i>`;

class More {

	public onMore: any;

	private $node: any;

	private _id: string;

	private moreButton: string;

	constructor( node: any ) {
		this.$node = node;
		this._id = this.$node.attr( 'id' );
		this.moreButton = `#${this._id} .ncCommmentMore`;
		this.onMore = new Util.Observer();
		this.addEvent();
	}

	public getMoreButton() {
		const $moreButton = jQuery( this.moreButton );
		if ( $moreButton.length ) {
			return $moreButton;
		}

		return jQuery( `<button class="ncCommmentMore">${Config.L10N.btn_more}</button>` );
	}

	public hideMoreButton() {
		jQuery( this.moreButton ).hide();
	}

	public showMoreButton() {
		this.$node.append( this.getMoreButton().show() );
	}

	private addEvent() {
		jQuery( 'body' ).on( 'click', `${this.moreButton}`, ( evt ) => {
			this.onMore.emit();
		});
	}
}

/**
 * GradeList
 */

class GradeList {

	private $node: any;

	private _id: string;

	private listId: string;

	private paramInfo: any;

	private loading: any;

	private page: number;

	private more: More;

	private lastPage: boolean;

	private isLoading: boolean;

	private isFirstLoaded: boolean;

	private pointList: string;

	constructor( node: any, options: any ) {
		this.$node = node;
		this.$node.addClass( Config.COMMUNITY_NODE );

		this._id = this.$node.attr( 'id' );
		this.listId = 'ncCommunityBoardList';

		jQuery.extend( true, Config, options );

		// parameter & hash Module - page, query, searchType, articleId
		this.paramInfo = new ParamInfo();
		this.paramInfo.setParamByUrl();

		this.loading = new Loading( this.$node );

		this.page = 0;
		this.lastPage = false;

		this.more = new More( this.$node );
		this.more.onMore.add( () => {

			if ( this.isLoading ) {
				return;
			}

			this.isLoading = true;
			this.get();
			this.more.hideMoreButton();
			this.loading.setUI();
		}, this);

		this.getSelector();
	}

	public setPaging() {
		return ++this.page;
	}

	public getPaging() {
		return this.page;
	}

	public getSelector() {
		this.pointList = `#${this._id} .profile-point-list`;
	}

	public get() {
		this.getList();
	}

	private newTemplate() {
		return NEW_ICON;
	}

	private listWrapTemplate( list: string ) {
		return `<ul class="profile-point-list">${list}</ul>`;
	}

	private listTemplate( data: any ) {
		if ( !data ) {
			return;
		}

		const _list: any = Util.Tmpl.iterate({
			data: data.pageList,
			template: ( pageList: any ) => {
				// DEPOSIT, WITHDRAW
				const _type = pageList.type;
				// let _date = pageList.dateTime;
				const _amount = pageList.amount;
				const _reason = pageList.reason;
				const _newIcon = Template.getNew( pageList.dateTime, this.newTemplate() );

				// DEPOSIT, WITHDRAW
				let iconCss = 'minus';
				let depositSymbol = '';
				let depositText = '차감';

				if ( _type ===  'DEPOSIT' ) {
					iconCss = 'plus';
					depositSymbol = '+';
					depositText = '적립';
				}

				return `<li class="profile-point-items">
				<span class="icon ${iconCss}">${depositText}</span>
				<span class="title">${_reason} ${depositSymbol}${_amount}${_newIcon}</span>
				<span class="date">${Template.getDateFormat( pageList.dateTime )}</span>
				</li>`;
			},
		});

		return _list;
	}

	private getList() {
		const pInfo = this.paramInfo;
		this.loading.show();

		// set parameter
		pInfo.setParamByUrl();

		let _pageSize = pInfo.getParamByKey( 'pageSize' );
		if ( _pageSize >= 100 ) {
			_pageSize = 100;
		}

		const list: any = Util.get( Config.gradeList(), 'GET', {
			pageSize: _pageSize || 10,
			page: this.setPaging(),
		});
		const list$ = Util.from( list );

		list$.subscribe( ( data: any ) => {
			if ( data.pageList.length === 0 && !this.isFirstLoaded ) {
				this.$node.append( Template.empty( this.listId, Config.L10N.list_none_point ) );
				this.more.hideMoreButton();
				return;
			}

			let _list = this.listTemplate( data );

			if ( !this.isFirstLoaded ) {
				_list = this.listWrapTemplate( _list );
				this.$node.append( _list );
			} else {
				jQuery( this.pointList ).append( _list );
			}

			this.isFirstLoaded = true;
			this.lastPage = data.lastPage;

			if ( this.lastPage ) {
				this.more.hideMoreButton();
			} else {
				this.more.showMoreButton();
			}

			this.loading.hide();
			this.isLoading = false;

		}, () => {
			this.loading.hide();
			this.isLoading = false;
		});
	}
}

export default GradeList;
